import AppCardWrapper from './AppCardWrapper';

export default AppCardWrapper;
